import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "commission", "notice"];
  static values = { baseNotice: String, selectedNotice: String };

  connect() {
    this.update();
  }

  update() {
    const option = this.selectTarget.selectedOptions[0];
    const selected = Boolean(this.selectTarget.value);

    this.commissionTarget.disabled = selected;
    this.noticeTarget.textContent = selected
      ? this.selectedNoticeValue.replace("%{percentage}", option.dataset.commissionDisplay)
      : this.baseNoticeValue;
  }
}
